import { Post } from '@/@types/post'
import { retrievePost } from '@/utils/fetchers/post'
import { modals } from '@mantine/modals'
import { isEmpty } from 'lodash-es'
import PostForm from './PostForm'
import { PostFormValue } from './PostForm/schemas'
import { toPostFormValue } from './PostForm/utils'
import RepostForm from './RepostForm/RepostForm'
import styles from './utils.module.css'

export function showPostFormModal(idOrPost?: string | Post) {
	let isEditMode = false
	let defaultFormValue: PostFormValue | undefined

	if (idOrPost) {
		const post = typeof idOrPost === 'string' ? retrievePost(idOrPost) : idOrPost
		if (!post) {
			return
		}
		defaultFormValue = toPostFormValue(post)
	}

	isEditMode = !isEmpty(defaultFormValue)
	const modalId = modals.open({
		title: `${isEditMode ? '编辑' : '发布'}动态`,
		children: <PostForm defaultValue={defaultFormValue} onSubmit={() => modals.close(modalId)} />,
	})
}

export function showRepostFormModal(target: Post) {
	const modalId = modals.open({
		title: '转发动态',
		children: (
			<RepostForm
				target={target!}
				onSubmit={() => void modals.close(modalId)}
				className={styles.repostForm}
			/>
		),
	})
}
